var map = {
	"./Boxes/bennevis.jpg": 3383,
	"./Boxes/choco.jpg": 83,
	"./Boxes/glow&lovely.jpg": 2855,
	"./Boxes/kasthamandap.jpg": 3634,
	"./Boxes/mangaldeep.jpg": 3251,
	"./Boxes/muesli.jpg": 4394,
	"./Boxes/muglan.jpg": 5511,
	"./Boxes/nb.jpg": 5105,
	"./Boxes/novabutter.jpg": 5397,
	"./Boxes/phoolprasad.jpg": 9810,
	"./Boxes/ponds.jpg": 461,
	"./Boxes/snplmangaldeep.jpg": 1636,
	"./Boxes/sunsilk.jpg": 6240,
	"./Boxes/toffichoo.jpg": 9094,
	"./Company logo/adagencies/Telejuprakashan.png": 3727,
	"./Company logo/adagencies/echo.png": 3738,
	"./Company logo/adagencies/kritya hub.png": 7106,
	"./Company logo/adagencies/max_media_pvt_ltd__logo.png": 7755,
	"./Company logo/adagencies/nepal traveller.png": 1330,
	"./Company logo/adagencies/pearl pub.png": 5920,
	"./Company logo/bank/EBL_LOGO.png": 7798,
	"./Company logo/bank/Himalayan everest insurance.png": 7287,
	"./Company logo/bank/Kumari-Bank-Limited.jpg": 4380,
	"./Company logo/bank/nchl.jpeg": 3489,
	"./Company logo/bank/prabhumahalaxmi.png": 899,
	"./Company logo/bank/siddhartha-premier-insurance.jpeg": 1480,
	"./Company logo/bank/siddhartha.png": 2139,
	"./Company logo/corporates/Better.png": 6181,
	"./Company logo/corporates/DLF greens.png": 5233,
	"./Company logo/corporates/Daraz-Logo.png": 963,
	"./Company logo/corporates/GWTN.png": 8947,
	"./Company logo/corporates/Golchha-Group-100-Years-of-Trust.png": 8525,
	"./Company logo/corporates/HMH.png": 332,
	"./Company logo/corporates/Heifer-Nepal-LogoH_CMYK.png": 9376,
	"./Company logo/corporates/Herveda-Botanicals-Logo2.webp": 7759,
	"./Company logo/corporates/JLECC_logo_0812.png": 4146,
	"./Company logo/corporates/KU.png": 7119,
	"./Company logo/corporates/KVC.png": 6245,
	"./Company logo/corporates/KWS.png": 9506,
	"./Company logo/corporates/Kansai_Nerolac_Paints_logo.svg.png": 6065,
	"./Company logo/corporates/Klab.png": 4931,
	"./Company logo/corporates/MAW.png": 2182,
	"./Company logo/corporates/Outreach.png": 2510,
	"./Company logo/corporates/Perfetti_Van_Melle_logo.svg": 3334,
	"./Company logo/corporates/Samsung_Brand_in_Nepal.png": 304,
	"./Company logo/corporates/UND.png": 6092,
	"./Company logo/corporates/Unilever.svg.png": 4905,
	"./Company logo/corporates/agni.png": 7268,
	"./Company logo/corporates/asian paints.png": 2636,
	"./Company logo/corporates/baltra.png": 9583,
	"./Company logo/corporates/bottlersnepal.png": 370,
	"./Company logo/corporates/ce.png": 5575,
	"./Company logo/corporates/cg.png": 4357,
	"./Company logo/corporates/dabur.png": 1031,
	"./Company logo/corporates/emai.png": 9327,
	"./Company logo/corporates/gorkha brewery.png": 5051,
	"./Company logo/corporates/helvetas.png": 6863,
	"./Company logo/corporates/hilife.png": 16,
	"./Company logo/corporates/himelectronics.png": 4912,
	"./Company logo/corporates/hotelmulberry.png": 6439,
	"./Company logo/corporates/kasthamandap.png": 2396,
	"./Company logo/corporates/kedia-main-logo.png": 6751,
	"./Company logo/corporates/nba.png": 8090,
	"./Company logo/corporates/nepalliquors.png": 4110,
	"./Company logo/corporates/phoolprasad.png": 5300,
	"./Company logo/corporates/piuro.png": 3364,
	"./Company logo/corporates/prismark.png": 1610,
	"./Company logo/corporates/pycus_holdings_pvt_ltd_logo.png": 7914,
	"./Company logo/corporates/rb diamonds.png": 8000,
	"./Company logo/corporates/roomtoreadlogocolor.png": 8143,
	"./Company logo/corporates/sab.png": 6393,
	"./Company logo/corporates/shivam_logo_9.png": 4135,
	"./Company logo/corporates/shree vairab.jpeg": 8058,
	"./Company logo/corporates/siddhipoly.png": 4296,
	"./Company logo/corporates/skylight.png": 6542,
	"./Company logo/corporates/sujal dairy.png": 3623,
	"./Company logo/corporates/sujal-foods-official-logo.png": 5008,
	"./Company logo/corporates/surya nepal.png": 1205,
	"./Company logo/corporates/thenepaldistilleries.jpeg": 9180,
	"./Company logo/corporates/urban foods.png": 6512,
	"./Company logo/corporates/vb.png": 3315,
	"./Company logo/corporates/vchitra.png": 7432,
	"./Company logo/ngo/ICRC logo card.png": 1369,
	"./Company logo/ngo/UNICEF-latest-logo.png": 7237,
	"./Company logo/ngo/VOW-Media.png": 9594,
	"./Company logo/ngo/equalaccess.png": 9595,
	"./Company logo/ngo/icimod.png": 5914,
	"./Company logo/ngo/ifes.png": 1704,
	"./Company logo/ngo/peeda.png": 4074,
	"./Company logo/ngo/pin.webp": 9440,
	"./Company logo/ngo/save the children.png": 1210,
	"./Company logo/ngo/undp.webp": 9422,
	"./Company logo/ngo/unesco.png": 6070,
	"./Company logo/ngo/unfpa-logo.png": 5269,
	"./Company logo/ngo/who.png": 5745,
	"./Company logo/ngo/worldvision.png": 3873,
	"./Company logo/resized logo/10equalaccess.jpg": 1725,
	"./Company logo/resized logo/11gwtn.jpg": 1038,
	"./Company logo/resized logo/12icrc.jpg": 20,
	"./Company logo/resized logo/13ifes.jpg": 8381,
	"./Company logo/resized logo/14peeda.jpg": 8420,
	"./Company logo/resized logo/15peopleinneed.jpg": 4450,
	"./Company logo/resized logo/16unesco.jpg": 730,
	"./Company logo/resized logo/17vowmedia.jpg": 5052,
	"./Company logo/resized logo/18worldvisioin.jpg": 9592,
	"./Company logo/resized logo/19suryanepal.jpg": 7144,
	"./Company logo/resized logo/1unicef.jpg": 2627,
	"./Company logo/resized logo/20kedia.jpg": 5902,
	"./Company logo/resized logo/21cg.jpg": 9605,
	"./Company logo/resized logo/22bottlers nepal.jpg": 2579,
	"./Company logo/resized logo/23gorkhabrewery.jpg": 4913,
	"./Company logo/resized logo/24unilever.jpg": 3104,
	"./Company logo/resized logo/25sujaldairy.jpg": 1573,
	"./Company logo/resized logo/26sujalfoods.jpg": 5656,
	"./Company logo/resized logo/27agnigroup.jpg": 1689,
	"./Company logo/resized logo/28nepaldistilleries.jpg": 2171,
	"./Company logo/resized logo/29sab.jpg": 3577,
	"./Company logo/resized logo/2who.jpg": 9702,
	"./Company logo/resized logo/30asianpaints.jpg": 5062,
	"./Company logo/resized logo/31dabur.jpg": 3806,
	"./Company logo/resized logo/32dlf.jpg": 9745,
	"./Company logo/resized logo/33emami.jpg": 3565,
	"./Company logo/resized logo/34golchha.jpg": 2027,
	"./Company logo/resized logo/35maw.jpg": 6635,
	"./Company logo/resized logo/36hilife.jpg": 8612,
	"./Company logo/resized logo/37himelectronics.jpg": 6373,
	"./Company logo/resized logo/38piuro.jpg": 606,
	"./Company logo/resized logo/39shivam.jpg": 2458,
	"./Company logo/resized logo/3icimod.jpg": 3706,
	"./Company logo/resized logo/40skylight.jpg": 5549,
	"./Company logo/resized logo/41und.jpg": 9842,
	"./Company logo/resized logo/42varun.jpg": 7082,
	"./Company logo/resized logo/43samsung.jpg": 639,
	"./Company logo/resized logo/44baltra.jpg": 5576,
	"./Company logo/resized logo/45ce.jpg": 7393,
	"./Company logo/resized logo/46daraz.jpg": 9260,
	"./Company logo/resized logo/47better.jpg": 2581,
	"./Company logo/resized logo/48kansainerolac.jpg": 9061,
	"./Company logo/resized logo/49rbdiamond.jpg": 3969,
	"./Company logo/resized logo/4undp.jpg": 5311,
	"./Company logo/resized logo/50shreevairab.jpg": 5651,
	"./Company logo/resized logo/51herveda.jpg": 6883,
	"./Company logo/resized logo/52nepalliquors.jpg": 8340,
	"./Company logo/resized logo/53kasthamandap.jpg": 5383,
	"./Company logo/resized logo/54urban.jpg": 1839,
	"./Company logo/resized logo/55perfetti.jpg": 3449,
	"./Company logo/resized logo/56phoolprasad.jpg": 2242,
	"./Company logo/resized logo/57ebl.jpg": 1045,
	"./Company logo/resized logo/58kumaribank.jpg": 6724,
	"./Company logo/resized logo/59siddhartha.jpg": 8984,
	"./Company logo/resized logo/5STC.jpg": 7379,
	"./Company logo/resized logo/60himalayaneverstinsureance.jpg": 4036,
	"./Company logo/resized logo/61prabhumahalaxmi.jpg": 6701,
	"./Company logo/resized logo/62siddharthapremier.jpg": 5524,
	"./Company logo/resized logo/63nchl.jpg": 5548,
	"./Company logo/resized logo/64jlecc.jpg": 3145,
	"./Company logo/resized logo/65ku.jpg": 2791,
	"./Company logo/resized logo/66kvc.jpg": 3788,
	"./Company logo/resized logo/67kws.jpg": 668,
	"./Company logo/resized logo/68nba.jpg": 1449,
	"./Company logo/resized logo/69nepaltraveller.jpg": 3288,
	"./Company logo/resized logo/69taleju.jpg": 5252,
	"./Company logo/resized logo/6heifer.jpg": 3069,
	"./Company logo/resized logo/70pearlpublication.jpg": 1851,
	"./Company logo/resized logo/71echoad.jpg": 7544,
	"./Company logo/resized logo/72maxmedia.jpg": 1545,
	"./Company logo/resized logo/73outreach.jpg": 1531,
	"./Company logo/resized logo/74prismark.jpg": 5984,
	"./Company logo/resized logo/75vchitra.jpg": 3413,
	"./Company logo/resized logo/76pycus.jpg": 4147,
	"./Company logo/resized logo/77siddhipoly.jpg": 69,
	"./Company logo/resized logo/78klab.jpg": 8529,
	"./Company logo/resized logo/79HMH.jpg": 9449,
	"./Company logo/resized logo/7helvetas.jpg": 8009,
	"./Company logo/resized logo/80hotelmulberry.jpg": 690,
	"./Company logo/resized logo/8rtr.jpg": 752,
	"./Company logo/resized logo/9unfpa.jpg": 2359,
	"./Posters/appy.jpg": 2564,
	"./Posters/baltra.jpg": 9614,
	"./Posters/bikalpa.jpg": 7756,
	"./Posters/cocacola.jpg": 3579,
	"./Posters/f&h.jpg": 472,
	"./Posters/frooti.jpg": 2397,
	"./Posters/fusion.jpg": 9146,
	"./Posters/gorkha.jpg": 9656,
	"./Posters/happydent.jpg": 3065,
	"./Posters/heifer.jpg": 6108,
	"./Posters/himalayaolevera.jpg": 282,
	"./Posters/jazzmandu.jpg": 8672,
	"./Posters/mangaldeep.jpg": 5860,
	"./Posters/mustang.jpg": 333,
	"./Posters/pepsi.jpg": 5563,
	"./Posters/redbull.jpg": 4161,
	"./Posters/signature.jpg": 8054,
	"./Posters/stc.jpg": 8196,
	"./Posters/sujal.jpg": 6169,
	"./Posters/suryanepal.jpg": 76,
	"./Posters/tadka.jpg": 6271,
	"./Posters/wheel.jpg": 6537,
	"./Posters/zsl.jpg": 2043,
	"./Streamers/bajaj.jpg": 1915,
	"./Streamers/gorkha.jpg": 8258,
	"./Streamers/holi.jpg": 7230,
	"./Streamers/khukri.jpg": 9678,
	"./Streamers/ponds.jpg": 2114,
	"./Streamers/samsung.jpg": 7294,
	"./Streamers/soaltee.jpg": 7487,
	"./Streamers/sujal.jpg": 8383,
	"./about us/about us (1)-01.JPG": 6121,
	"./about us/about us (1).JPG": 4313,
	"./about us/about us (1).png": 1056,
	"./about us/about us (2).png": 2781,
	"./about us/about us (3).png": 246,
	"./about us/about us (4).png": 6923,
	"./about us/about us (5).png": 7332,
	"./about us/about us (6).png": 8113,
	"./aboutUsLanding.jpeg": 5380,
	"./ad-1.png": 1306,
	"./bank-1.png": 5475,
	"./bank-2.png": 4632,
	"./book-1.jpg": 8390,
	"./book-10.jpg": 6764,
	"./book-11.jpg": 4137,
	"./book-12.jpg": 7998,
	"./book-13.jpg": 4459,
	"./book-14.jpg": 1624,
	"./book-15.jpg": 2533,
	"./book-16.jpg": 1546,
	"./book-17.jpg": 4199,
	"./book-18.jpg": 2548,
	"./book-19.jpg": 1073,
	"./book-2.jpg": 6145,
	"./book-20.jpg": 4781,
	"./book-21.jpg": 3536,
	"./book-22.jpg": 7263,
	"./book-23.jpg": 5554,
	"./book-24.jpg": 785,
	"./book-25.jpg": 2628,
	"./book-26.jpg": 8691,
	"./book-27.jpg": 8582,
	"./book-28.jpg": 7778,
	"./book-29.jpg": 1080,
	"./book-3.jpg": 1812,
	"./book-30.jpg": 9801,
	"./book-31.jpg": 6947,
	"./book-32.jpg": 4372,
	"./book-4.jpg": 9599,
	"./book-5.jpg": 7890,
	"./book-6.jpg": 3821,
	"./book-7.jpg": 5248,
	"./book-8.jpg": 6859,
	"./book-9.jpg": 8814,
	"./catalog-1.jpg": 6872,
	"./catalog-10.jpg": 2482,
	"./catalog-11.jpg": 8863,
	"./catalog-2.jpg": 1095,
	"./catalog-3.jpg": 6634,
	"./catalog-4.jpg": 8473,
	"./catalog-5.jpg": 6748,
	"./catalog-6.jpg": 9547,
	"./catalog-7.jpg": 8414,
	"./catalog-8.jpg": 9661,
	"./catalog-9.jpg": 4080,
	"./corporate-1.png": 3212,
	"./corporate-2.png": 1687,
	"./gallery-1.png": 4051,
	"./gallery-2.png": 9560,
	"./gallery-3.png": 7825,
	"./gallery-4.png": 1710,
	"./gallery-5.png": 4727,
	"./gallery-6.png": 4092,
	"./grandfather.jpg": 751,
	"./grandfather1.jpg": 6690,
	"./grandfather2.jpeg": 82,
	"./grandfatherHistory.jpeg": 4336,
	"./hardbound-1.jpg": 2180,
	"./hardbound-2.jpg": 2227,
	"./hardbound-3.jpg": 614,
	"./hardbound-4.jpg": 7485,
	"./hardbound-5.jpg": 1920,
	"./hardbound-6.jpg": 4911,
	"./hardbound-7.jpg": 8530,
	"./hardbound-8.jpg": 9337,
	"./logo.png": 2806,
	"./machine-1.png": 3842,
	"./machine-2.png": 7849,
	"./machine-3.png": 2096,
	"./machine-4.png": 7967,
	"./magazine-1.jpg": 8419,
	"./magazine-2.jpg": 2356,
	"./magazine-3.jpg": 6689,
	"./magazine-4.jpg": 8434,
	"./magazine-5.jpg": 143,
	"./magazine-6.jpg": 5792,
	"./ngo-1.png": 3125,
	"./ngo-2.png": 7374,
	"./ourService.jpg": 7856,
	"./sample-book-1.png": 5765,
	"./sample-book-2.png": 6033,
	"./sample-book-3.png": 6727,
	"./sample-landing.jpg": 3863,
	"./sample-landing.png": 2439,
	"./sample-magazine-1.png": 4768,
	"./sample-magazine-2.jpeg": 3404,
	"./sample-magazine-2.png": 171,
	"./sample-magazine-3.png": 6514,
	"./sample-poster-1.png": 6857,
	"./sample-poster-2.png": 274,
	"./sample.jpeg": 1554,
	"./sample1.png": 5760,
	"./sample2.png": 4443,
	"./sample3.png": 5442,
	"./sewa team expanded.png": 1293,
	"./sewa team.jpg": 8812,
	"./sewa team.png": 2184,
	"./sewaBuilding.jpeg": 2244,
	"./sewaTeam.png": 4800,
	"./storybook-1.jpg": 3661,
	"./storybook-2.jpg": 3762,
	"./storybook-3.jpg": 6143,
	"./testimonial-2.png": 9668,
	"./testimonial-3.png": 8062,
	"./testimonial-4.png": 5777,
	"./testimonials/arun kaji sthapit.jpg": 4738,
	"./testimonials/keshav pradhan.jpg": 8570,
	"./testimonials/testimonial-2.jpeg": 9235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;